import { Box, Button, Paper, Typography } from '@mui/material';
import { ExportButtonSx } from '../gamification-dash/dqShared';

const ExportCsvButton = ({ label, onClick, disabled }) => (
  <Button
    variant="contained"
    onClick={onClick}
    disabled={disabled}
    sx={ExportButtonSx}
    startIcon={
      <Box component="img" src="/icons/export-csv.svg" alt="export" sx={{ width: 40, height: 24 }} />
    }
  >
    {label}
  </Button>
);

const MessagesAnalysisExportSection = ({
  periodLabel,
  loading,
  onExportRegistered,
  onExportAllUsers,
  onExportFeedback,
}) => (
  <Paper sx={{ mt: 3, p: 2 }}>
    <Typography variant="h6" sx={{ fontSize: 20 }}>
      Export for message analysis
      {periodLabel ? (
        <Typography component="span" variant="body2" color="textSecondary" sx={{ ml: 1 }}>
          ({periodLabel})
        </Typography>
      ) : null}
    </Typography>
    <Typography variant="body2" color="textSecondary" sx={{ mt: 0.5, mb: 2 }}>
      Full-period CSV exports for the monthly MAIA analysis pipeline. Not affected by table filters.
    </Typography>
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <ExportCsvButton label="Export all users" onClick={onExportAllUsers} disabled={loading} />
      <ExportCsvButton label="Export registered" onClick={onExportRegistered} disabled={loading} />
      <ExportCsvButton label="Export feedback" onClick={onExportFeedback} disabled={loading} />
    </Box>
  </Paper>
);

export default MessagesAnalysisExportSection;
